<template>
  <section class="dte-card dte-footer-card" v-if="documentData.notes || documentData.showLargeAmountResponsibles">
    <div class="dte-card__header">Observaciones</div>
    <div class="dte-card__body" style="display: grid; gap: 14px;">
      <div v-if="documentData.notes" class="dte-footer-card__notes">
        <p class="dte-footer-note">{{ documentData.notes }}</p>
      </div>

      <div v-if="documentData.showLargeAmountResponsibles" class="dte-footer-contacts">
        <div class="dte-footer-contacts__card">
          <p class="dte-section-title">Responsable Emisor</p>
          <div class="dte-definition-list">
            <div class="dte-definition-list__row">
              <dt>Nombre</dt>
              <dd>{{ documentData.footerContacts.issuerName || "---" }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Documento</dt>
              <dd>{{ documentData.footerContacts.issuerDocument || "---" }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Telefono</dt>
              <dd>{{ documentData.footerContacts.issuerPhone || "---" }}</dd>
            </div>
          </div>
        </div>

        <div class="dte-footer-contacts__card">
          <p class="dte-section-title">Responsable Receptor</p>
          <div class="dte-definition-list">
            <div class="dte-definition-list__row">
              <dt>Nombre</dt>
              <dd>{{ documentData.footerContacts.receiverName || "---" }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Documento</dt>
              <dd>{{ documentData.footerContacts.receiverDocument || "---" }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Telefono</dt>
              <dd>{{ documentData.footerContacts.receiverPhone || "---" }}</dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DteFooterSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
};
</script>
